import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StockService } from './logic/stock.service';
import { StockLogicService } from './logic/stock/stock-logic.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: StockService, useClass: StockLogicService }
  ]
})
export class StockModule {}
